const readCookie = (name) => {
    const cookieSource = typeof document !== 'undefined' ? document.cookie : '';

    const regexValue = '=([^;]+)';
    const match = cookieSource.match(new RegExp(name + regexValue));
    let result = '';

    if (match && match.length > 0) {
        try {
            result = JSON.parse(decodeURIComponent(match[1]));
        } catch (e) {
            result = '';
        }
    }

    return result;
};

const getHav = () => {
    let hav;
    // did we already get it server side?
    if (typeof window !== 'undefined') {
        hav = (window.tripboardConfig && window.tripboardConfig.hav) || '';
    }
    if (!hav) {
        hav = readCookie('hav');
    }
    return hav;
};

export {getHav};
